import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'

import { getFormattedLot } from 'models/reservedParking'
import { showModal } from 'components/Atoms/Modal/actions'

import Multiparking from './Screen'

const MultiparkingHOC = props => {
  const {
    eventLink,
    hasEvent,
    hasMonthly,
    hasOnDemand,
    lot,
    monthlyLink,
    onDemandLink,
  } = props
  const countries = useSelector(state => state.countries.countries)
  const dispatch = useDispatch()

  const formattedLot = getFormattedLot({
    countries,
    node: { lot },
    addressFormat: 'street',
  })

  const onLotDetailsClick = () =>
    dispatch(
      showModal({
        childProps: {
          hideHowToPark: true,
          lot: formattedLot,
          shouldUseLocation: false,
          title: formattedLot?.name,
        },
        modalProps: {
          className: 'noBorders',
          open: true,
          customStyle: {
            top: '0',
          },
        },
        fullScreen: false,
        modalType: 'lotDetails',
      })
    )

  return (
    <Multiparking
      {...props}
      eventLink={eventLink}
      hasEvent={hasEvent}
      hasOnDemand={hasOnDemand}
      hasMonthly={hasMonthly}
      lot={lot}
      onDemandLink={onDemandLink}
      onLotDetailsClick={onLotDetailsClick}
      monthlylink={monthlyLink}
    />
  )
}

MultiparkingHOC.propTypes = {
  eventLink: PropTypes.string,
  hasEvent: PropTypes.bool,
  hasMonthly: PropTypes.bool,
  hasOnDemand: PropTypes.bool,
  lot: PropTypes.object,
  monthlyLink: PropTypes.string,
  onDemandLink: PropTypes.string,
}

export default MultiparkingHOC
